module.exports = __webpack_public_path__ + "img/FormatBrushIcon.9a5f0056.svg";